import React from 'react'
import { usePostRequest } from '../hooks/request'
import { DUE_DATE_LIST } from '../urls'
import DueDateForm from './DueDateForm'

export default function DueDateCreate({ onCancel, onSuccess, dueId }) {
    const rotationCreate = usePostRequest({ url: DUE_DATE_LIST })

    async function onSubmit(data, actions) {
        const { success } = await rotationCreate.request({ data: { ...data, due: dueId } })

        if (success) {
            onSuccess()
            actions.resetForm()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <DueDateForm onSubmit={onSubmit} onCancel={onCancel} loading={rotationCreate.loading} />
        </div>
    )
}
